import {
  FETCH_SERVICES,
  CREATE_MODEL,
  fetchServicesSuccess,
  fetchServicesError,
  fetchServicesBusy,
  createModelSuccess,
  createModelError,
  createModelBusy,
} from "./action";
import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { readServices, createModel } from "./api";

import { ActionTypes } from "../util";
import { BUSY_GLOBAL } from "../busy/action";
import { logError } from "utils/utils";
import { parse } from "utils/async";
import { setMessage } from "controllers/common/action";
import { transformModelPayload } from "controllers/models/saga";
import { Intent } from "@blueprintjs/core";

const { REQUEST } = ActionTypes;

export function* readServicesSaga() {
  try {
    yield put(fetchServicesBusy(true));
    yield put(fetchServicesError());
    const response = yield call(readServices);
    const parsed = [];
    for (const r of response) {
      const temp = yield call(parse, r);
      parsed.push(temp);
    }
    yield put(fetchServicesSuccess(parsed));
  } catch (error) {
    logError(error);
    yield put(fetchServicesError(error.message));
  } finally {
    yield put(fetchServicesBusy(false));
  }
}

export function* createModelSaga(action) {
  const { body, message } = transformModelPayload(action.payload);
  try {
    yield put(createModelBusy(BUSY_GLOBAL));
    yield put(createModelError());
    const response = yield call(createModel, body);
    yield put(createModelSuccess(response ? response : "Success"));
    yield put(setMessage({ text: message, intent: Intent.SUCCESS }));
  } catch (error) {
    logError(error);
    yield put(createModelError(error.message));
  } finally {
    yield put(createModelBusy(false));
  }
}

export default function* servicesSaga() {
  yield takeEvery(FETCH_SERVICES[REQUEST], readServicesSaga);
  yield takeLatest(CREATE_MODEL[REQUEST], createModelSaga);
}
